/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconPerson = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      fill={fill}
      viewBox="0 0 21 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <circle
        cx={10.6}
        cy={6.4}
        r={5.4}
        stroke={stroke}
        strokeWidth={weight === "normal" ? 1.5 : 1}
      />
      <path
        stroke={stroke}
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
        d="M20.2 25H1c0-7.017 4.298-12.706 9.6-12.706S20.2 17.983 20.2 25z"
      />
    </svg>
  ),
);
